import React from 'react';

import { ContentMetadata, ContentType } from '@candu-ai/content/types';
import { ContentPlacements } from '@candu-ai/placement/content-placements';

interface Props {
  content: ContentMetadata;
}

export const PlacementsPage = React.memo(({ content }: Props) => {
  return (
    <ContentPlacements
      contentType={content.contentType}
      contentId={content.id}
      slug={content.slug}
      context={{
        maxPlacements:
          content.contentType === ContentType.Modal ||
          content.contentType === ContentType.HotspotGroup
            ? 1
            : undefined,
      }}
    />
  );
});
